module.exports = __webpack_public_path__ + "static/media/login_image.803d188f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_image.png
// module id = 1597
// module chunks = 0